export default "__VITE_ASSET__44b52574__"